import { createFileRoute } from "@tanstack/react-router";

import { MirrorPage } from "@/components/MirrorPage";
import { content } from "@/mirror/page/privacy-healthcare-professionals";
import { requireUnlockedHome } from "@/lib/gate.functions";
import { mirrorHead } from "@/mirror/pages";

export const Route = createFileRoute("/privacy/healthcare-professionals")({
  loader: () => requireUnlockedHome(),
  head: () => mirrorHead("privacy-healthcare-professionals"),
  component: () => <MirrorPage key="privacy-healthcare-professionals" slug="privacy-healthcare-professionals" content={content} />,
});
